module.exports = __webpack_public_path__ + "img/Photo_2___Fourth_Canal_978_36_18.8774a3a4.jpg";